



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaEdit, FaSave } from "react-icons/fa";
// import {
//     getCateringBillingDataAPI,
//     saveOrUpdateCateringBillingAPI,
// } from "../../../Servicefile/SettingsAndControlService.jsx";
// // Inline loader hook (same as Userdetails component)
// const useInlineLoader = () => {
//     const [loading, setLoading] = useState(false);
//     const [fadeOut, setFadeOut] = useState(false);

//     const showLoader = () => {
//         setFadeOut(false);
//         setLoading(true);
//     };

//     const hideLoader = () => {
//         setFadeOut(true);
//         setTimeout(() => {
//             setLoading(false);
//             setFadeOut(false);
//         }, 500);
//     };

//     return { showLoader, hideLoader, loading, fadeOut };
// };

// // Loader Component (same as Userdetails component)
// const Loader = ({ loading, fadeOut, text = "Loading..." }) => {
//     if (!loading) return null;

//     return (
//         <div style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: 'rgba(0,0,0,0.95)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 999999,
//             transition: 'opacity 0.4s ease',
//             fontFamily: 'Arial, sans-serif',
//             opacity: fadeOut ? 0 : 1,
//             pointerEvents: fadeOut ? 'none' : 'auto'
//         }}>
//             <div style={{ textAlign: 'center' }}>
//                 <div style={{
//                     fontSize: '2rem',
//                     fontWeight: 900,
//                     letterSpacing: '6px',
//                     marginBottom: '30px',
//                 }}>
//                     {"MAAMAAS".split("").map((l, i) => (
//                         <span
//                             key={i}
//                             style={{
//                                 display: 'inline-block',
//                                 opacity: 0,
//                                 transform: 'translateY(30px)',
//                                 animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
//                                 color: '#e50914',
//                             }}
//                         >
//                             {l}
//                         </span>
//                     ))}
//                 </div>

//                 <div style={{
//                     width: '280px',
//                     height: '4px',
//                     background: 'rgba(255,255,255,0.2)',
//                     overflow: 'hidden',
//                     margin: '0 auto',
//                 }}>
//                     <div style={{
//                         width: '40%',
//                         height: '100%',
//                         background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
//                         animation: 'progress 1.8s infinite',
//                     }}></div>
//                 </div>

//                 <div style={{
//                     marginTop: '20px',
//                     color: '#aaa',
//                     fontSize: '14px',
//                 }}>
//                     {text}
//                 </div>
//             </div>
//         </div>
//     );
// };

// const Cateringbillingsetup = () => {
//     const billingFields = [
//         { label: "Commission", key: "commission" },
//         { label: "Commission GST", key: "commissionGst" },
//         { label: "GST", key: "gst" },
//         { label: "Platform Fee", key: "platformFee" },
//         { label: "Lead Price", key: "leadPercentage" },
//         { label: "Delivery Fee per km", key: "deliveryFeeperThousandperKm" },
//         { label: "Partial Payment", key: "partialPayment" },
//         { label: "TopRated Fee", key: "topRated" },
//     ];

//     const [billingData, setBillingData] = useState({});
//     const [editMode, setEditMode] = useState({});
//     const [loading, setLoading] = useState(false);

//     // Use inline loader (same as Userdetails component)
//     const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();

//     useEffect(() => {
//         fetchBillingData();
//     }, []);

//     const fetchBillingData = async () => {
//         try {
//             showLoader();

//             const data = await getCateringBillingDataAPI();

//             console.log("📦 Billing API response:", data);

//             const initializedData = billingFields.reduce(
//                 (acc, { key }) => {
//                     acc[key] = Number(data[key]) || 0;

//                     let backendKey;

//                     if (key === "commission") {
//                         backendKey = "commisionApplicable";
//                     } else if (
//                         key === "deliveryFeeperThousandperKm"
//                     ) {
//                         backendKey =
//                             "deliveryFeeperkmApplicable";
//                     } else {
//                         backendKey = `${key}Applicable`;
//                     }

//                     const val = data[backendKey];

//                     acc[`${key}Applicable`] =
//                         val === true ||
//                         val === "true" ||
//                         val === 1;

//                     return acc;
//                 },
//                 {
//                     id: data.id || 0,
//                     couponAmount:
//                         Number(data.couponAmount) || 0,
//                     distance: Number(data.distance) || 0,
//                 }
//             );

//             setBillingData(initializedData);

//         } catch (error) {
//             console.error(
//                 "❌ Error fetching billing data:",
//                 error
//             );
//         } finally {
//             hideLoader();
//         }
//     };

//     const toggleEdit = (key) => {
//         setEditMode((prev) => ({ ...prev, [key]: !prev[key] }));
//     };

//     const handleValueChange = (key, value) => {
//         setBillingData((prev) => ({ ...prev, [key]: value }));
//     };

//     const handleCheckboxChange = (key) => {
//         const applicableKey = `${key}Applicable`;
//         setBillingData((prev) => ({
//             ...prev,
//             [applicableKey]: !prev[applicableKey],
//         }));
//     };

//     const handleSaveOrUpdate = async (key) => {
//         setLoading(true);

//         try {
//             await saveOrUpdateCateringBillingAPI(
//                 billingData,
//                 billingFields
//             );

//             alert("Billing settings saved successfully!");

//             // Close edit mode
//             if (key) {
//                 setEditMode((prev) => ({
//                     ...prev,
//                     [key]: false,
//                 }));
//             } else {
//                 setEditMode({});
//             }

//             // Refresh latest data
//             fetchBillingData();

//         } catch (error) {
//             console.error(
//                 "❌ Error saving/updating billing data:",
//                 error.response?.data || error.message
//             );

//             alert(
//                 `Failed to save/update billing settings: ${error.response?.data?.message ||
//                 error.message
//                 }`
//             );
//         } finally {
//             setLoading(false);
//         }
//     };


//     return (
//         <div style={containerStyle}>
//             {/* Global Loader (same as Userdetails component) */}
//             <Loader loading={globalLoading} fadeOut={fadeOut} text="Loading billing data..." />

//             {/* Add loader animations to existing style */}
//             <style>{`
//                 @keyframes letterAnim {
//                     0% { opacity: 0; transform: translateY(30px); }
//                     100% { opacity: 1; transform: translateY(0); }
//                 }

//                 @keyframes progress {
//                     0% { transform: translateX(-100%); }
//                     100% { transform: translateX(250%); }
//                 }
//             `}</style>

//             {/* Table with Fixed Headers - IMPROVED VERSION */}
//             <div style={{
//                 border: '1px solid #ddd',
//                 borderRadius: '4px',
//                 overflow: 'hidden',
//                 marginTop: '10px'
//             }}>
//                 {/* Fixed Header - Separated from scrollable content */}
//                 <div style={{
//                     backgroundColor: 'rgb(230 109 51)',
//                     borderBottom: '2px solid rgb(230 109 51)',
//                     position: 'sticky',
//                     top: 0,
//                     zIndex: 10
//                 }}>
//                     <div
//                         style={{
//                             display: 'grid',
//                             gridTemplateColumns: '300px 300px 300px 300px',
//                             width: '100%'
//                         }}>
//                         <div style={{ ...fixedHeaderCellStyle }}>Charge Type</div>
//                         <div style={{ ...fixedHeaderCellStyle }}>Percentage (%)</div>
//                         <div style={{ ...fixedHeaderCellStyle }}>Visibility</div>
//                         <div style={{ ...fixedHeaderCellStyle }}>Actions</div>
//                     </div>
//                 </div>

//                 {/* Scrollable Body */}
//                 <div style={{
//                     maxHeight: "500px",
//                     overflowY: "auto",
//                     backgroundColor: '#fff'
//                 }}>
//                     {billingFields.map(({ label, key }, index) => (
//                         <div
//                             key={key}
//                             style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: '300px 300px 300px 300px',
//                                 width: '100%',
//                                 backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
//                                 borderBottom: index < billingFields.length - 1 ? '1px solid #ddd' : 'none'
//                             }}
//                         >
//                             {/* Charge Type */}
//                             <div style={gridCellStyle}>
//                                 <strong>{label}</strong>
//                             </div>

//                             {/* Percentage */}
//                             <div style={gridCellStyle}>
//                                 {editMode[key] ? (
//                                     <input
//                                         type="number"
//                                         value={billingData[key] || ""}
//                                         onChange={(e) => handleValueChange(key, e.target.value)}
//                                         style={inputStyle}
//                                     />
//                                 ) : (
//                                     <span>{billingData[key] || "—"}</span>
//                                 )}
//                             </div>

//                             {/* Visibility */}
//                             <div style={gridCellStyle}>
//                                 <input
//                                     type="checkbox"
//                                     checked={Boolean(billingData[`${key}Applicable`])}
//                                     disabled={!editMode[key]}
//                                     onChange={() => handleCheckboxChange(key)}
//                                 />
//                             </div>

//                             {/* Actions */}
//                             <div style={gridCellStyle}>
//                                 {editMode[key] ? (
//                                     <FaSave
//                                         onClick={() => handleSaveOrUpdate(key)}
//                                         style={{ ...iconStyle, color: "#4caf50" }}
//                                         title="Save"
//                                     />
//                                 ) : (
//                                     <FaEdit
//                                         onClick={() => toggleEdit(key)}
//                                         style={{ ...iconStyle }}
//                                         title="Edit"
//                                     />
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
//                 <button
//                     onClick={() => handleSaveOrUpdate()}
//                     style={saveButtonStyle}
//                     onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
//                     onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
//                 >
//                     Save All
//                 </button>
//             </div>
//         </div>
//     );
// };

// // Styles
// const containerStyle = { maxWidth: 1200, margin: "0 auto", fontFamily: "Segoe UI, sans-serif", padding: "0 20px" };

// // Fixed header cell style
// const fixedHeaderCellStyle = {
//     padding: '12px',
//     color: '#fff',
//     fontWeight: 'bold',
//     textAlign: 'center',
//     borderRight: '1px solid rgba(255,255,255,0.2)',
//     fontSize: '14px'
// };

// // Grid cell style for body rows
// const gridCellStyle = {
//     padding: '12px',
//     textAlign: 'center',
//     borderRight: '1px solid #ddd',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     minHeight: '50px'
// };

// const inputStyle = {
//     width: '80px',
//     padding: '5px',
//     border: "1px solid #ccc",
//     borderRadius: 5,
//     textAlign: "center"
// };

// const iconStyle = {
//     fontSize: 20,
//     cursor: "pointer",
//     margin: "0 5px"
// };

// const saveButtonStyle = {
//     padding: "10px 20px",
//     backgroundColor: "#4CAF50",
//     color: "#fff",
//     border: "none",
//     borderRadius: 5,
//     cursor: "pointer",
//     fontWeight: "bold",
//     transition: "background-color 0.3s",
// };

// export default Cateringbillingsetup;




import React, { useState, useEffect } from "react";
import { FaEdit, FaSave, FaCheckCircle, FaSpinner, FaEye, FaEyeSlash } from "react-icons/fa";
import { MdOutlineSettingsSuggest, MdOutlineAttachMoney } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import {
    getCateringBillingDataAPI,
    saveOrUpdateCateringBillingAPI,
} from "../../../Servicefile/SettingsAndControlService.jsx";

// ─── Premium Loader ──────────────────────────────────────────────
const PremiumLoader = ({ loading, fadeOut, text = "Loading..." }) => {
    if (!loading) return null;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: fadeOut ? 0 : 1 }}
            transition={{ duration: 0.5 }}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(255, 248, 240, 0.96)',
                backdropFilter: 'blur(16px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 999999,
                fontFamily: "'Inter', 'Segoe UI', sans-serif",
                pointerEvents: fadeOut ? 'none' : 'auto',
            }}
        >
            <div style={{ textAlign: 'center', maxWidth: 400, padding: '0 20px' }}>
                <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                >
                    <div style={{
                        fontSize: '2.8rem',
                        fontWeight: 800,
                        letterSpacing: '6px',
                        marginBottom: '28px',
                        background: 'linear-gradient(135deg, #e66d33, #e66d33, #e66d33)',
                        backgroundSize: '200% 200%',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        animation: 'gradientMove 3s ease-in-out infinite',
                    }}>
                        MAAMAAS
                    </div>
                </motion.div>

                <div style={{ position: 'relative', width: 70, height: 70, margin: '0 auto 20px' }}>
                    <svg width="70" height="70" viewBox="0 0 70 70">
                        <circle
                            cx="35" cy="35" r="28"
                            fill="none"
                            stroke="rgba(230, 126, 34, 0.15)"
                            strokeWidth="4"
                        />
                        <motion.circle
                            cx="35" cy="35" r="28"
                            fill="none"
                            stroke="url(#loaderGrad)"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeDasharray="176"
                            initial={{ strokeDashoffset: 176 }}
                            animate={{ strokeDashoffset: 0 }}
                            transition={{
                                duration: 1.6,
                                ease: "easeInOut",
                                repeat: Infinity,
                            }}
                        />
                        <defs>
                            <linearGradient id="loaderGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#e66d33" />
                                <stop offset="100%" stopColor="#e66d33" />
                            </linearGradient>
                        </defs>
                    </svg>
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: '#e66d33',
                        fontSize: '11px',
                        fontWeight: 700,
                    }}>
                        <FaSpinner style={{ animation: 'spin 1s linear infinite', fontSize: 18 }} />
                    </div>
                </div>

                <motion.p
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    style={{
                        color: '#7f6b5d',
                        fontSize: '13px',
                        letterSpacing: '0.3px',
                        fontWeight: 500,
                    }}
                >
                    {text}
                </motion.p>
            </div>

            <style>{`
                @keyframes gradientMove {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </motion.div>
    );
};

// ─── Custom Hook ────────────────────────────────────────────────
const usePremiumLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };

    return { showLoader, hideLoader, loading, fadeOut };
};

// ─── Main Component ─────────────────────────────────────────────
const Cateringbillingsetup = () => {
    const billingFields = [
        { label: "Commission", key: "commission", icon: "💰" },
        { label: "Commission GST", key: "commissionGst", icon: "🧾" },
        { label: "GST", key: "gst", icon: "🏷️" },
        { label: "Platform Fee", key: "platformFee", icon: "⚙️" },
        { label: "Lead Price", key: "leadPercentage", icon: "📈" },
        { label: "Delivery Fee / km", key: "deliveryFeeperThousandperKm", icon: "🚚" },
        { label: "Partial Payment", key: "partialPayment", icon: "💳" },
        { label: "TopRated Fee", key: "topRated", icon: "⭐" },
    ];

    const [billingData, setBillingData] = useState({});
    const [editMode, setEditMode] = useState({});
    const [saving, setSaving] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [hoveredRow, setHoveredRow] = useState(null);

    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = usePremiumLoader();

    useEffect(() => {
        fetchBillingData();
    }, []);

    const fetchBillingData = async () => {
        try {
            showLoader();
            const data = await getCateringBillingDataAPI();

            const initializedData = billingFields.reduce(
                (acc, { key }) => {
                    acc[key] = Number(data[key]) || 0;

                    let backendKey;
                    if (key === "commission") backendKey = "commisionApplicable";
                    else if (key === "deliveryFeeperThousandperKm") backendKey = "deliveryFeeperkmApplicable";
                    else backendKey = `${key}Applicable`;

                    const val = data[backendKey];
                    acc[`${key}Applicable`] = val === true || val === "true" || val === 1;
                    return acc;
                },
                {
                    id: data.id || 0,
                    couponAmount: Number(data.couponAmount) || 0,
                    distance: Number(data.distance) || 0,
                }
            );

            setBillingData(initializedData);
        } catch (error) {
            console.error("❌ Error fetching billing data:", error);
        } finally {
            hideLoader();
        }
    };

    const toggleEdit = (key) => {
        setEditMode((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleValueChange = (key, value) => {
        setBillingData((prev) => ({ ...prev, [key]: value }));
    };

    const handleCheckboxChange = (key) => {
        const applicableKey = `${key}Applicable`;
        setBillingData((prev) => ({
            ...prev,
            [applicableKey]: !prev[applicableKey],
        }));
    };

    const handleSaveOrUpdate = async (key) => {
        setSaving(true);
        setSaveSuccess(false);

        try {
            await saveOrUpdateCateringBillingAPI(billingData, billingFields);
            setSaveSuccess(true);
            setTimeout(() => setSaveSuccess(false), 3000);

            if (key) {
                setEditMode((prev) => ({ ...prev, [key]: false }));
            } else {
                setEditMode({});
            }

            fetchBillingData();
        } catch (error) {
            console.error("❌ Error saving:", error);
            alert(`Failed to save: ${error.response?.data?.message || error.message}`);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={containerStyle}>
            <PremiumLoader loading={globalLoading} fadeOut={fadeOut} text="Loading billing data..." />

            {/* Header */}
            <motion.div
                initial={{ opacity: 0, y: -15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                style={headerStyle}
            >
                {/* <div style={headerLeftStyle}>
                    <div style={headerIconWrapper}>
                        <MdOutlineSettingsSuggest size={28} color="#e66d33" />
                    </div>
                    <div>
                        <h1 style={headerTitleStyle}>Catering Billing</h1>
                        <p style={headerSubStyle}>Manage all billing parameters and charges</p>
                    </div>
                </div> */}
                {/* <div style={headerBadgeStyle}>
                    <span style={badgeDotStyle} />
                    <span style={badgeTextStyle}>Active</span>
                </div> */}
            </motion.div>

            {/* Table Card */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.1 }}
                style={cardStyle}
            >
                {/* Table */}
                <div style={tableWrapperStyle}>
                    {/* Header Row */}
                    <div style={headerRowStyle}>
                        <div style={{ ...headerCellStyle, width: '30%', textAlign: 'left', paddingLeft: 24 }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <MdOutlineAttachMoney size={16} />
                                Charge Type
                            </span>
                        </div>
                        <div style={{ ...headerCellStyle, width: '20%', textAlign: 'center' }}>Value (%)</div>
                        <div style={{ ...headerCellStyle, width: '22%', textAlign: 'center' }}>Status</div>
                        <div style={{ ...headerCellStyle, width: '28%', textAlign: 'right', paddingRight: 24 }}>Action</div>
                    </div>

                    {/* Body */}
                    <div style={bodyScrollStyle}>
                        {billingFields.map(({ label, key, icon }, index) => {
                            const isEditing = editMode[key];
                            const isHovered = hoveredRow === key;
                            const isActive = Boolean(billingData[`${key}Applicable`]);

                            return (
                                <motion.div
                                    key={key}
                                    initial={{ opacity: 0, x: -8 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.25, delay: index * 0.04 }}
                                    onMouseEnter={() => setHoveredRow(key)}
                                    onMouseLeave={() => setHoveredRow(null)}
                                    style={{
                                        ...rowStyle,
                                        background: isHovered ? '#fef9f4' : (index % 2 === 0 ? '#ffffff' : '#fcf9f7'),
                                        borderLeft: isActive ? '3px solid #e66d33' : '3px solid transparent',
                                    }}
                                >
                                    {/* Charge Type */}
                                    <div style={{ ...cellStyle, width: '30%', justifyContent: 'flex-start', paddingLeft: 24 }}>
                                        <span style={iconStyleSmall}>{icon}</span>
                                        <span style={labelStyle}>{label}</span>
                                        {isActive && (
                                            <span style={activeDotStyle} />
                                        )}
                                    </div>

                                    {/* Value */}
                                    <div style={{ ...cellStyle, width: '20%' }}>
                                        {isEditing ? (
                                            <input
                                                type="number"
                                                value={billingData[key] || ""}
                                                onChange={(e) => handleValueChange(key, e.target.value)}
                                                style={inputStyle}
                                                step="0.01"
                                                min="0"
                                                autoFocus
                                            />
                                        ) : (
                                            <span style={valueStyle}>
                                                {billingData[key] !== undefined && billingData[key] !== null
                                                    ? `${billingData[key]}%`
                                                    : "—"
                                                }
                                            </span>
                                        )}
                                    </div>

                                    {/* Status */}
                                    <div style={{ ...cellStyle, width: '22%' }}>
                                        <label style={checkboxLabelStyle}>
                                            <input
                                                type="checkbox"
                                                checked={isActive}
                                                disabled={!isEditing}
                                                onChange={() => handleCheckboxChange(key)}
                                                style={checkboxStyle}
                                            />
                                            <span style={{
                                                ...statusTextStyle,
                                                color: isActive ? '#e66d33' : '#b0a094',
                                            }}>
                                                {isActive ? 'Active' : 'Inactive'}
                                            </span>
                                        </label>
                                    </div>

                                    {/* Actions */}
                                    <div style={{ ...cellStyle, width: '28%', justifyContent: 'flex-end', paddingRight: 24, gap: 10 }}>
                                        {isEditing ? (
                                            <motion.button
                                                whileHover={{ scale: 1.03 }}
                                                whileTap={{ scale: 0.95 }}
                                                onClick={() => handleSaveOrUpdate(key)}
                                                style={{ ...actionBtnStyle, background: '#e66d33' }}
                                            >
                                                <FaSave size={14} />
                                                <span>Save</span>
                                            </motion.button>
                                        ) : (
                                            <motion.button
                                                whileHover={{ scale: 1.03 }}
                                                whileTap={{ scale: 0.95 }}
                                                onClick={() => toggleEdit(key)}
                                                style={{ ...actionBtnStyle, background: '#e66d33' }}
                                            >
                                                <FaEdit size={14} />
                                                <span>Edit</span>
                                            </motion.button>
                                        )}
                                    </div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>

                {/* Footer */}
                <div style={footerStyle}>
                    <div style={footerLeftStyle}>
                        {saveSuccess && (
                            <motion.div
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                style={successBadgeStyle}
                            >
                                <FaCheckCircle color="#e66d33" size={18} />
                                <span>Settings saved successfully!</span>
                            </motion.div>
                        )}
                        {/* <span style={footerCountStyle}>
                            {billingFields.length} parameters configured
                        </span> */}
                    </div>
                    <motion.button
                        whileHover={{ scale: 1.02, boxShadow: '0 8px 25px rgba(230, 126, 34, 0.35)' }}
                        whileTap={{ scale: 0.97 }}
                        onClick={() => handleSaveOrUpdate()}
                        style={saveAllButtonStyle}
                        disabled={saving}
                    >
                        {saving ? (
                            <>
                                <FaSpinner style={{ animation: 'spin 1s linear infinite', marginRight: 10 }} size={16} />
                                Saving...
                            </>
                        ) : (
                            'Save All Changes'
                        )}
                    </motion.button>
                </div>
            </motion.div>

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.4; }
                }
                * { box-sizing: border-box; }
                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f5f0eb;
                    border-radius: 10px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #e66d33;
                    border-radius: 10px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: #d35400;
                }
            `}</style>
        </div>
    );
};

// ─── Premium Orange Theme Styles ──────────────────────────────

const containerStyle = {
  
};

const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 12,
};

const headerLeftStyle = {
    display: "flex",
    alignItems: "center",
    gap: 16,
};

const headerIconWrapper = {
    width: 48,
    height: 48,
    borderRadius: 14,
    background: "rgba(230, 126, 34, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const headerTitleStyle = {
    fontSize: "clamp(1.3rem, 3vw, 1.8rem)",
    fontWeight: 700,
    color: "#2c1810",
    letterSpacing: "-0.3px",
    margin: 0,
    lineHeight: 1.2,
};

const headerSubStyle = {
    fontSize: "clamp(12px, 1vw, 14px)",
    color: "#8a7a6e",
    margin: "2px 0 0 0",
    fontWeight: 400,
};

const headerBadgeStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "rgba(230, 126, 34, 0.08)",
    padding: "6px 18px",
    borderRadius: 100,
    border: "1px solid rgba(230, 126, 34, 0.15)",
};

const badgeDotStyle = {
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#e66d33",
    display: "inline-block",
    animation: "pulse 2s infinite",
};

const badgeTextStyle = {
    fontSize: "13px",
    fontWeight: 600,
    color: "#e66d33",
};

const cardStyle = {
    background: "#ffffff",
    borderRadius: 18,
    boxShadow: "0 8px 40px rgba(0,0,0,0.05), 0 2px 12px rgba(0,0,0,0.03)",
    overflow: "hidden",
    border: "1px solid rgba(230, 126, 34, 0.06)",
};

const tableWrapperStyle = {
    overflow: "hidden",
};

const headerRowStyle = {
    display: "flex",
    background: "linear-gradient(135deg, #e66d33, #e66d33)",
    padding: "0 4px",
    borderBottom: "3px solid #e66d33",
};

const headerCellStyle = {
    padding: "14px 12px",
    color: "#ffffff",
    fontWeight: 600,
    fontSize: "clamp(11px, 0.9vw, 13px)",
    textTransform: "uppercase",
    letterSpacing: "0.4px",
    flexShrink: 0,
    opacity: 0.85,
};

const bodyScrollStyle = {
    maxHeight: "420px",
    overflowY: "auto",
    padding: "0 4px",
};

const rowStyle = {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #f0ebe6",
    padding: "8px 0",
    transition: "all 0.2s ease",
    borderRadius: 4,
    margin: "2px 0",
};

const cellStyle = {
    padding: "6px 12px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontSize: "clamp(12px, 0.9vw, 14px)",
    gap: 8,
    minHeight: 44,
};

const iconStyleSmall = {
    fontSize: "clamp(16px, 1.2vw, 20px)",
    opacity: 0.7,
};

const labelStyle = {
    fontWeight: 500,
    color: "#2c1810",
    fontSize: "clamp(13px, 0.95vw, 14px)",
};

const activeDotStyle = {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#e66d33",
    display: "inline-block",
    flexShrink: 0,
};

const valueStyle = {
    fontWeight: 600,
    color: "#2c1810",
    fontSize: "clamp(13px, 0.95vw, 14px)",
};

const inputStyle = {
    width: "80px",
    padding: "6px 8px",
    border: "2px solid #e66d33",
    borderRadius: 8,
    fontSize: "clamp(12px, 0.9vw, 14px)",
    fontWeight: 500,
    textAlign: "center",
    background: "#fffaf5",
    outline: "none",
    transition: "all 0.2s",
    color: "#2c1810",
};

const checkboxLabelStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    fontSize: "clamp(11px, 0.85vw, 13px)",
    fontWeight: 500,
};

const checkboxStyle = {
    width: 16,
    height: 16,
    accentColor: "#e66d33",
    cursor: "pointer",
    borderRadius: 4,
};

const statusTextStyle = {
    fontWeight: 500,
    transition: "color 0.2s",
};

const actionBtnStyle = {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 16px",
    border: "none",
    borderRadius: 8,
    color: "#fff",
    fontWeight: 600,
    fontSize: "clamp(11px, 0.85vw, 13px)",
    cursor: "pointer",
    transition: "all 0.2s",
    boxShadow: "0 3px 12px rgba(230, 126, 34, 0.2)",
    letterSpacing: "0.3px",
};

const footerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 24px",
    borderTop: "1px solid #f0ebe6",
    background: "#fcf9f7",
    flexWrap: "wrap",
    gap: 10,
};

const footerLeftStyle = {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
};

const successBadgeStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "rgba(230, 126, 34, 0.1)",
    padding: "4px 14px",
    borderRadius: 100,
    fontSize: "clamp(12px, 0.9vw, 13px)",
    fontWeight: 500,
    color: "#e66d33",
};

const footerCountStyle = {
    fontSize: "clamp(11px, 0.8vw, 12px)",
    color: "#b0a094",
    fontWeight: 400,
};

const saveAllButtonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: "10px 28px",
    background: "linear-gradient(135deg, #e66d33, #e66d33)",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontWeight: 700,
    fontSize: "clamp(13px, 1vw, 15px)",
    cursor: "pointer",
    transition: "all 0.3s",
    boxShadow: "0 4px 20px rgba(230, 126, 34, 0.25)",
    minWidth: 160,
    letterSpacing: "0.3px",
};

// ─── Responsive Inject ──────────────────────────────────────────

const responsiveStyles = `
    @media (max-width: 820px) {
        .row-style, .header-row {
            flex-wrap: wrap;
            padding: 10px 4px;
        }
        .cell-style, .header-cell-style {
            width: 50% !important;
            justify-content: center;
            padding: 4px 6px;
            font-size: 12px;
            min-height: 38px;
        }
        .cell-style:last-child, .header-cell-style:last-child {
            width: 100% !important;
            justify-content: center !important;
            padding-right: 6px !important;
            padding-left: 6px !important;
        }
        .action-btn {
            padding: 5px 12px;
            font-size: 11px;
        }
        .action-btn span {
            display: inline;
        }
        .input-style {
            width: 65px;
            padding: 4px 6px;
            font-size: 12px;
        }
        .footer-style {
            flex-direction: column;
            align-items: stretch;
            text-align: center;
            padding: 12px 16px;
        }
        .save-all-btn {
            width: 100%;
            min-width: unset;
        }
        .footer-left {
            justify-content: center;
        }
    }
    @media (max-width: 500px) {
        .container-style {
            padding: 12px 8px;
        }
        .header-style {
            flex-direction: column;
            align-items: flex-start;
        }
        .header-title {
            font-size: 1.1rem;
        }
        .header-sub {
            font-size: 11px;
        }
        .cell-style, .header-cell-style {
            font-size: 11px;
            padding: 2px 4px;
            min-height: 34px;
            gap: 4px;
        }
        .checkbox-label {
            font-size: 10px;
        }
        .checkbox-style {
            width: 14px;
            height: 14px;
        }
        .action-btn {
            padding: 4px 10px;
            font-size: 10px;
            gap: 4px;
        }
        .action-btn span {
            display: none;
        }
        .action-btn svg {
            font-size: 13px;
        }
        .save-all-btn {
            font-size: 12px;
            padding: 8px 16px;
        }
        .icon-small {
            font-size: 14px !important;
        }
        .label-style {
            font-size: 11px !important;
        }
        .value-style {
            font-size: 12px !important;
        }
        .input-style {
            width: 50px;
            padding: 3px 4px;
            font-size: 11px;
        }
        .footer-count {
            font-size: 10px;
        }
        .success-badge {
            font-size: 11px;
            padding: 2px 10px;
        }
        .header-icon-wrapper {
            width: 38px;
            height: 38px;
        }
        .header-badge {
            padding: 4px 12px;
        }
    }
`;

const styleTag = document.createElement("style");
styleTag.textContent = responsiveStyles;
document.head.appendChild(styleTag);

export default Cateringbillingsetup;